import { licenseStatusSchema } from '../../../../backend/extraTypes';
import { licenseCheckLatestStatusListViewName, } from '../../../../backend/features/credentialing-verification/shared';
import { useCredentialingTranslation } from '../../../../ui/hooks';
import { formatDateCustom } from '@juvare/common-web-ui/utils';
import { useClientSideExport } from '@juvare/platform-sdk-react/ui/features/clientside-export';
import { useViewClient } from '@juvare/platform-sdk-react/ui/hooks';
export const useLicenseCheckLatestStatusListViewExport = ({ filter, orderBy }) => {
    const { t } = useCredentialingTranslation();
    const licenseCheckLatestStatusListViewClient = useViewClient(licenseCheckLatestStatusListViewName);
    const header = [
        t('table.credentialingVerification.personName'),
        t('table.credentialingVerification.occupationName'),
        t('table.credentialingVerification.credentialName'),
        t('table.credentialingVerification.status'),
        t('table.credentialingVerification.requestDate'),
        t('table.credentialingVerification.requestedBy'),
    ];
    const handleConvertData = ({ personName, occupationName, credentialName, status, requestDate, requestedBy, }) => {
        const statusParseResult = licenseStatusSchema.safeParse(status);
        const licenseStatus = statusParseResult.success ? statusParseResult.data : 'unknown';
        return [
            personName,
            occupationName,
            credentialName,
            t(`licenseStatuses.${licenseStatus}`),
            requestDate ? formatDateCustom(new Date(requestDate), 'dd/MM/yyyy hh:mm:ss') : '',
            requestedBy !== null && requestedBy !== void 0 ? requestedBy : '',
        ];
    };
    const { handleExport: handleExportLicenseCheckLatestStatuses } = useClientSideExport({
        header,
        fileName: 'license-check-latest-status',
        onConvertData: handleConvertData,
        onFetchData: ({ offset, limit }) => {
            return licenseCheckLatestStatusListViewClient.list({
                offset,
                limit,
                filter,
                orderBy,
            });
        },
    });
    return { handleExportLicenseCheckLatestStatuses };
};
